<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "voimaa_pakaratreenilla_osa_2";
    let title = "Parhaat liikkeet pakaratreeniin";
    let author = "Mata";
    let blogDate = "14.2.2023";
    let titlePic = "2023/suorinjaloinmave1.jpg";
    let firstPara = "Pakara-artikkelien toisessa osassa käymme läpi parhaat liikkeet kehon vahvimman lihasryhmän kehittämiseksi.";
</script>

<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"/>

            <p>
                <a href="voimaa_pakaratreenilla_osa_1">Edellisessä artikkelissa</a> 
                kävimme läpi pakaralihasten roolia kehon toiminnassa. Kävimme myös
                läpi pari helppoa testiä, joilla voit kokeilla osaatko aktivoida
                pakaralihaksesi.
            </p>
            <p>
                Mikäli pakaralihaksesi aktivoituvat moitteettomasti, on
                ehdottomasti tehokkain tapa treenata pakaroita ns. suurilla
                moninivelliikkeillä. Kyykky eri variaatioineen sekä suorinjaloin
                tehtävät maastavedot ovat tähän tehokkaimpia.
            </p>
            <p>
                Jos aktivaatiossa on puutteita, on hyvä ottaa treeniin mukaan
                myös aktivaatiota parantavia, kohdistetumpia täsmäliikkeitä,
                joilla harjoitus osuu paremmin suoraan kohdelihakseen. Käymme
                näitä liikkeitä tarkemmin artikkelisarjan kolmannessa osassa.
            </p>
            <p>
                Pakaralihakset ovat (tai ainakin niiden tulisi olla) ihmisen
                voimakkain lihasryhmä. Passiivinen elämäntapa ja yksipuoliset
                treenitottumukset saattavat kuitenkin saada lihakset “uinumaan”.
                Saliharjoittelussa tämä näkyy ongelmina hermotuksessa,
                vaikeuksina saata tuntumaa pakaroihin ja kehityksen
                pysähtymistä. Kehon suurimpana liasryhmänä pakaran uinuminen
                muodostuu pullonkaulaksi joka vaikuttaa kaikken kehitykseen.
            </p>
            <p>
                Tässä artikkelissa käymme läpi pakaroiden lihasten toiminta sekä
                pohdimme mahdollisia syitä, mikäli jalkatreeni ei tunnu
                pakaroissa ja miten sen saisi siellä tuntumaan. Käymme myös läpi
                joitakin pakaran toimintahäiriöiden vaikutuksia liikkeeseen ja
                asennonhallintaan.
            </p>
            <p>
                Erityisesti vapailla painoilla ja kehonpainolla harjoiteltaessa
                tarvittavan puristusvoiman merkitys korostuu.
            </p>

            <h2>Parhaat pakaraliikkeet</h2>
            <p>
                Kehomme on tehty liikkumista varten, ja saliharjoittelun tulisi
                tukea tätä liikkumista. Kaiken kuntosalilla tapahtuvan treenin
                tulisi siis olla tarkoituksenmukaista ja kehon toimintaa tukevaa
                niin, että harjoitteluvaikutus siirtyy myös salin ulkopuolelle.
            </p>
            <h3>Eristävät vs. moninivelliikkeet</h3>
            <p>
                Perustreenissä kannattaa suosia kokonaisvaltaisia, suuria
                liikkeitä, joissa aktivoituu koko kroppa. Jos tavoite on samalla
                kasvattaa lihasmassaa, suurilla liikkeillä on mahdollista saada
                suuri treenivaste.
            </p>
            <p>
                Eristävät liikkeet tulevat avuksi, kun treenataan tiettyjä
                lajeja tai tilanteita varten tai halutaan opetella
                lihasaktivaatiota tai tehdä korjaavia liikkeitä. Eristävillä
                liikkeillä yksin ei ole mahdollista saada suuria ja voimakkaita
                parakalihaksia, sillä ne eivät koskaan toimi yksin eristettynä
                muusta kropasta. Suurin teho kropasta ja pakaroista saadaan irti
                silloin kun työskennellään suurten kuormien kanssa.
            </p>
            <h3>Kyykky - pakaraliikkeiden kuningas</h3>
            <p>
                Kyykky on kiistatta tehokkain liike pakaroiden treenaamiseen -
                mikäli siinä suoritustekniikka on kunnossa. Käyn tässä läpi
                tärkeimmät kyykkyliikkeet sekä niiden merkitys pakaralihaksen
                kannalta.
            </p>

            <h4>Takakyykky vs. etukyykky</h4>
            <div class="img_container">
                <img
                    src="/svelte-site/img/blog/2023/starting_strength_squat.jpeg"
                    alt="Kyykyn asento"
                    style="max-height:600px"
                />
                <p class="kuvateksti">Kuva: Mark Rippetoe: Starting Strength</p>
            </div>
            <p>
                Optimitilanteessa takakyykyssä tangon ollessa painopisteen
                päällä, polvi ja lonkka liikkuvat suhteessa saman verran. Siksi
                takakyykyssä voimme liikutella suurempia voimia.
            </p>
            <p>
                Etukyykyssä liike lonkkanivelestä jää pienemmäksi ja polvi
                liikkuu enemmän. Näin saadaan pakaroista vähemmän voimaa irti
                kuin takakyykyssä. Tämä ei ole yhtään sen enempää väärin, mutta
                muuttaa hieman nivelkulmia ja voimantuottoa ja on hyvä ottaa
                huomioon harjoittelussa.
            </p>
            <p>
                Kyykyssä - riippumatta valitusta kyykkytavasta - on tärkeä
                huomioida muutama seikka.
            </p>
            <ol>
                <li>
                    Huomioi selkärangan neutraali asento. Rintarangan yliojennus
                    vähentää keskivartalon voimantuottoa.
                </li>
                <li>
                    Polvi liikkuu 2. varpaan päälle. Paino pysyy pottuvarpaan
                    tyvinivelellä, ei siirretä painopistettä ulkosyrjälle.
                    Polven kierto 2. varpaan päälle tapahtuu siis pakarasta, ei
                    painopisteen viemisellä ulkosyrjälle.
                </li>
                <li>
                    Polvi ylittää etusuunnassa varvaslinjan - se on sallittua ja
                    täysin normaalia.
                </li>
            </ol>

            <h4>
                Askelkyykky - epäsymmetria tuo askeleen lähemmäs tosielämän
                liikettä
            </h4>
            <div class="img_container">
                <img
                    src="/svelte-site/img/blog/2023/askelkyykky.png"
                    alt="Askelkyykky kahvakuulalla"
                    style="max-height:600px"
                />
                <p class="kuvateksti">Askelkyykky kahvakuulalla</p>
            </div>
            <p>
                Askelkyykyssä on samat perusperiaatteet kuin takakyykyssä, mutta
                epäsymmetria vastaa enemmän sitä liikettä mikä tapahtuu
                kuntosalin ulkopuolella, arjessamme. Epäsymmetrian vuoksi liike
                aktivoi pakaraa vielä paremmin. Kuten etu- ja takakyykyssä,
                samat säännöt linjauksista pätevät myös askelkyykyssä
            </p>
            <p>
                Askelkyykyn pituus ja painopiste vaikuttaa kohdistukseen.
                Nyrkkisääntönä pitkä askelkyykky kohdistuu enemmän pakaraan,
                lyhyt enemmän reiden etuosaan, kun paino on molemmilla jaloilla.
            </p>
            <p>
                Myös askelkyykyssä polvi liukuu edestä katsottuna 2. varpaan
                päälle ja reiden linja pysyy suorana. Linjauksen pettäminen voi
                johtua siitä, että pakara ei tee hommaansa vaan päästää lantion
                liukumaan sivuun. Tällöin keskimmäinen ja pieni pakaralihas ei
                aktivoidu riittävästi.
            </p>
            <p>
                Mainittakoon myös, että sivulle tehtävät kyykyt on hyödyllinen
                lisä liikesuuntien hallintaan, mutta en käy sitä tässä sen
                enempää läpi.
            </p>

            <h3>Suorin jaloin maastaveto</h3>

            <div class="img_container">
                <img
                    src="/svelte-site/img/blog/2023/suorinjaloinmave.jpg"
                    alt="Yhden jalan suorin jaloin maastaveto kahvakuulalla"
                    style="max-height:400px"
                />
                <p class="kuvateksti">
                    Yhden jalan suorin jaloin maastaveto kahvakuulalla
                </p>
            </div>
            <p>
                Suorin jaloin tehtävä maastaveto kohdistuu erityisesti
                takaketjuun: takareisiin, alaselkään ja pakaroihin. Liike
                kehittää erinomaisesti samalla liikkuvuutta, hallintaa ja
                voimaa. Liikkeessä pyritään siihen että alas mennessä säilyy
                lannerangan notko, polvet pysyvät kevyesti pehmeänä.
            </p>
            <p>
                Kahdella jalalla tehtynä suorin jaloin maastavedossa korostuu
                reiden takaosan tekemä työ. Yhdellä jalalla kohdistus osuu
                enemmän pakaroihin. Tällöin tukijalan pakaran tulee hallita
                lantion asentoa. Kahvakuulalla tehtynä liike aktivoi pakaran
                parhaiten, kun kuorma on vastakkaisen käden puolella. Tällöin
                pakaran tulee stabilida vartalon kiertoa jotta kuula ei vie
                ristikkäiseen suuntaan.
            </p>

            <p>
                Näillä liikkeillä saat varmasti pakaroihin voimaa. Seuraavassa
                artikkelissa pureudumme pakaroiden aktivoimiseen apuliikkeiden
                avulla.
            </p>
        </article>


        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='kunto_nousuun_kelkkaharjoittelulla' title='Kunto nousuun kelkkaharjoittelulla' titlePic='2018/kelkat.jpg' blogDate='' firstPara='Urheilijat ovat kautta historian käyttäneet kelkkaa osana fysiikkaharjoittelua nopeusvoima- ja kunto-ominaisuuksien kehittämiseen. Myös tavallinen kuntoilija hyötyy kelkkaharjoittelusta.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='voimaa_pakaratreenilla_osa_3' title='Näin aktivoit nukkuvan pakaran' titlePic='2023/kyykky1.jpg' blogDate='' firstPara='Artikkelisarjan kolmannessa osassa kertaamme nukkuvan pakaran oireyhtymän sekä käymme läpi harjoituksia, joilla voit treenata pakara-aktivaatiota.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='voimaharjoittelun_pikaopas' title='Voimaharjoittelun pikaopas: Voiman lajit tutuiksi' titlePic='voimaharjoittelu.jpg' blogDate='' firstPara='Voima on elämisen perusehto. Lihakset tuottavat voimaa, mikä havaitaan nivelten liikkeenä tai kykynä ylläpitää asentoa. Ilman lihasvoimaa emme pysty liikkumaan, emme edes seisomaan paikallamme.'></BlogSummary>
                </article>
            </div>
        </section>

    </div>
{/if}

<style>
    .img_container {
        margin: 2em 0;
    }
</style>
